// extracted by mini-css-extract-plugin
export default {"content":"gallery_content","fadeIn":"gallery_fadeIn","title":"gallery_title"};